import React, { useEffect,useState } from 'react';
import UserHeader from "../user/UserHeader";
import UserSidebar from "../user/UserSidebar";
import { useSelector } from 'react-redux';
import "../../assets/css/psidebar.css";

const Layout = ({ children }) => {
    const [state, setState] = useState({
        sidebarOpen: "sidebar open",
        Open: true,
        main: "menu-left-300",
        toggleClass: "bi bi-chevron-left",
    });


    const handleResize = () => {
        if (window.innerWidth < 720) {
           
        
            setState({
                sidebarOpen: "sidebar close",
                Open: false,
                main: "menu-left-0",
                toggleClass: "bi bi-chevron-right",
            })
            
        } else {
          
            setState({
                sidebarOpen: "sidebar open",
                Open: true,
                main: "menu-left-300",
                toggleClass: "bi bi-chevron-left",
            })
        }
      }

     
      
    useEffect(() => {
        window.addEventListener("resize", handleResize) 
       

        const completeurl = window.location.href;
      if (
        completeurl ===
          globalThis.config.Settings.ApiConfiguration.Appurl +globalThis.config.Settings.ApiConfiguration.BaseURL +
            "DFODashboard/as" ||
        completeurl ===
          globalThis.config.Settings.ApiConfiguration.Appurl +globalThis.config.Settings.ApiConfiguration.BaseURL + "DFODashboard"
      ){
        if (window.innerWidth > 720) {
        setState({
            sidebarOpen: "sidebar close",
            Open: false,
            main: "menu-left-0",
            toggleClass: "bi bi-chevron-right",
        })
    }

    

    window.addEventListener("resize", handleResize) 
      }

      
      },[null])

    const activemenu = "";

    const handleViewSidebar = () => {
        setState((prevState) => {
            const newOpen = !prevState.Open;
            return {
                ...prevState,
                Open: newOpen,
                sidebarOpen: newOpen ? "sidebar open" : "sidebar close",
                main: newOpen ? "menu-left-300" : "menu-left-0",
                toggleClass: newOpen ? "bi bi-chevron-left" : "bi bi-chevron-right",
            };
        });
    };

    const { user: currentUser, isLoggedIn } = useSelector((state) => state.auth);
    const [isSidebarClosed, setSidebarClosed] = useState(true);



    const [menuState, setMenuState] = useState({
      category: false,
      posts: false,
      plugins: false,
    });
    const toggleSidebar = () => {      
        setSidebarClosed(!isSidebarClosed);

        !isSidebarClosed==true? document.getElementById("menu_sidebar").classList.add("close"):
        document.getElementById("menu_sidebar").classList.remove("close");
      };
     
      // Toggle individual menu open/close state
      const toggleMenu = (menu) => {
       
        setMenuState((prevState) => ({
          category: false,
          posts: false,
          plugins: false
        }));
     
        setMenuState((prevState) => ({
          ...prevState,
          [menu]: !prevState[menu],
        }));
        console.log(menu, 'menu toggled:', menuState[menu]); // Debugging: check if state changes
      };

    return (
        <>
            <UserHeader />
            {isLoggedIn ? (
                <>
                    <UserSidebar isOpen={state.sidebarOpen} activemenu={activemenu} handleViewSidebar={handleViewSidebar}/>
                    {/* <main id="main" className={state.main}>
                        <section>
                            <button onClick={handleViewSidebar} className="sidebar-toggle">
                                <i className={state.toggleClass}></i>
                            </button>
                            <div>{children}</div>
                        </section>
                    </main> */}

                    {/* <div className="home-section">
                        <div className="home-content">
                            <i className="bx bx-menu position-top"/> */}
                            
                        {/* </div>
                    </div> */}
                    {/* {children} */}
                    <section className="home-section">
                        <div className="home-content">
                        <i 
  className={`bx ${isSidebarClosed ? 'bx-chevron-right' : 'bx-chevron-left'} ${isSidebarClosed ? 'position-top' : 'position-top-expand'}`} 
  onClick={toggleSidebar} 
/>


{/* <box-icon name='left-arrow-circle'></box-icon> */}
                            <span>
                                {children}
                            </span>                           
                        </div>
                    </section>
                </>
            ) : (
                 <div>
                    {children}                    
                    </div>
            )}

        </>
    );
}

export default Layout;
